window.dataLayer = window.dataLayer || [];

var GA4_DEBUG = true;
function ga4log(event, payload) {
  if (!GA4_DEBUG) return;
  console.groupCollapsed('%c[GA4] ' + event, 'color: #4285f4; font-weight: bold;');
  console.log(payload);
  console.groupEnd();
}

// ─── add_to_cart ────────────────────────────────────────────────────────────
document.addEventListener('variant:add', function (event) {
  var productData = window.__ga4_product_data;
  if (!productData) {
    console.warn('[GA4] add_to_cart: __ga4_product_data не знайдено');
    return;
  }

  var variantId = parseInt(event.detail.variant.id, 10);
  var variant = productData.variants.find(function (v) {
    return v.id === variantId;
  });

  var price = variant ? variant.price / 100 : productData.price / 100;

  var payload = {
    event: 'add_to_cart',
    ecommerce: {
      currency: productData.currency,
      value: price,
      items: [
        {
          item_id: String(productData.id),
          item_name: productData.title,
          item_brand: productData.vendor,
          item_category: productData.type,
          item_variant: variant ? variant.title : '',
          price: price,
          quantity: event.detail.quantity || 1
        }
      ]
    }
  };

  dataLayer.push({ ecommerce: null });
  dataLayer.push(payload);
  ga4log('add_to_cart', payload);
});

// ─── begin_checkout ──────────────────────────────────────────────────────────
document.addEventListener('click', function (event) {
  var btn = event.target.closest('[name="checkout"]');
  if (!btn) return;

  var cartData = window.__ga4_cart_data;
  if (!cartData || !cartData.items || cartData.items.length === 0) {
    console.warn('[GA4] begin_checkout: __ga4_cart_data порожній або не знайдено');
    return;
  }

  var payload = {
    event: 'begin_checkout',
    ecommerce: {
      currency: cartData.currency,
      value: cartData.total_price / 100,
      items: cartData.items.map(function (item) {
        return {
          item_id: String(item.product_id),
          item_name: item.product_title,
          item_brand: item.vendor,
          item_category: item.product_type,
          item_variant: item.variant_title || '',
          price: item.price / 100,
          quantity: item.quantity
        };
      })
    }
  };

  dataLayer.push({ ecommerce: null });
  dataLayer.push(payload);
  ga4log('begin_checkout', payload);
});

// ─── cart_abandonment_trigger ────────────────────────────────────────────────
if (document.body.classList.contains('template-cart')) {
  var abandonmentFired = false;
  document.addEventListener('mouseleave', function (event) {
    if (abandonmentFired) return;
    if (event.clientY <= 0) {
      abandonmentFired = true;
      var payload = { event: 'cart_abandonment_trigger' };
      dataLayer.push(payload);
      ga4log('cart_abandonment_trigger', payload);
    }
  });
}

// ─── form_error ───────────────────────────────────────────────────────────────
document.addEventListener('cart:error', function (event) {
  var payload = {
    event: 'form_error',
    error_type: 'cart',
    error_message: event.detail.errors || event.detail.message || ''
  };
  dataLayer.push(payload);
  ga4log('form_error', payload);
});
